import React from 'react';
import {
    CREATE,
    translate,
    withDataProvider,
} from 'react-admin';
import {
    Fab,
    Tooltip,
} from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Add';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

export default translate(withDataProvider(({
    dataProvider,
    translate,
}) => {
    const dispatch = useDispatch();
    return <Tooltip title={translate('resources.playlist.action.create')}>
        <Fab
            color="primary"
            onClick={() => {
                dataProvider(
                    CREATE,
                    'playlist',
                    {
                        autoFill: true,
                    },
                    {
                        onSuccess: {
                            notification: {
                                body: 'resources.playlist.notification.created',
                                info: 'info',
                            },
                            refresh: true,
                        },
                        onError: {
                            notification: {
                                body: 'resources.playlist.notification.creation_failed',
                                info: 'warning',
                            },
                            refresh: false,
                        },
                    })
                    .then((response) => dispatch(push(`/playlist/${response.data.id}`)));
            }}
        >
            <CreateIcon />
        </Fab>
    </Tooltip>;
}));
